<template>
<div class="chapter">
<div class="inner_page">
<p class="C106"><a id="page_vii">CONTENTS</a></p><a id="page_vii">
</a><p class="C108"><a id="page_vii"></a><a href="#/xhtml/06_INTRODUCTION#page_1">INTRODUCTION</a></p>
<p class="C91"><a href="#/xhtml/07_1__TALK_OF_THE_TOWN__Beginnings#page_6">1. TALK OF THE TOWN: Beginnings</a></p>
<p class="C91"><span href="#/xhtml/08_2__UP_THE_NECK__Pretenders#page_34" title="Link target outside of Sample">2. UP THE NECK: <em>Pretenders</em></span></p>
<p class="C91"><span href="#/xhtml/09_3__BIRDS_OF_PARADISE__Extended_P#page_54" title="Link target outside of Sample">3. BIRDS OF PARADISE: <em>Extended Play</em> and <em>Pretenders II</em></span></p>
<p class="C91"><span href="#/xhtml/10_4__TIME_THE_AVENGER__Learning_to#page_72" title="Link target outside of Sample">4. TIME THE AVENGER: <em>Learning to Crawl</em></span></p>
<p class="C91"><span href="#/xhtml/11_5__DON_T_GET_ME_WRONG__Get_Close#page_89" title="Link target outside of Sample">5. DON’T GET ME WRONG: <em>Get Close</em> and <em>Packed!</em></span></p>
<p class="C91"><span href="#/xhtml/12_6__LEGALISE_ME__Last_of_the_Inde#page_115" title="Link target outside of Sample">6. LEGALISE ME: <em>Last of the Independents</em> and <em>¡Viva El Amor!</em></span></p>
<p class="C91"><span href="#/xhtml/13_7__COMPLEX_PERSON__Loose_Screw_a#page_134" title="Link target outside of Sample">7. COMPLEX PERSON: <em>Loose Screw</em> and <em>Break Up the Concrete</em></span></p>
<p class="C108"><span href="#/xhtml/14_8__YOU_OR_NO_ONE__Fidelity___Sto#page_153" title="Link target outside of Sample">8. YOU OR NO ONE: <em>Fidelity!</em>, <em>Stockholm</em>, and <em>Reckless</em></span></p>
<p class="C91"><span href="#/xhtml/15_ACKNOWLEDGMENTS#page_167" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="C91"><span href="#/xhtml/16_SOURCES_AND_NOTES#page_169" title="Link target outside of Sample">SOURCES AND NOTES</span></p>
<p class="C91"><span href="#/xhtml/17_SELECTED_DISCOGRAPHY#page_181" title="Link target outside of Sample">SELECTED DISCOGRAPHY</span></p>
<p class="C91"><span href="#/xhtml/18_INDEX#page_185" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?84f92600